import React from 'react';
import InvestmentCalculators from '../components/InvestmentCalculators';
import SEO from '../components/SEO';

const CalculatorsPage = () => {
  return (
    <div>
      <SEO 
        title="Investment Calculators | SIP, SWP, STP, Retirement, Child Education, Arabpati | Rubicon Finservices"
        description="Free investment calculators for smart financial planning - SIP Calculator, SWP Calculator, STP Calculator, Retirement Planner, Child Education Calculator, and Arabpati (₹100 Crore) Calculator. Download PDF reports and plan your wealth journey today."
        keywords="SIP calculator, mutual fund calculator, retirement calculator, SWP calculator, STP calculator, child education calculator, wealth planning calculator, investment planning tools, financial calculators India, arabpati calculator, 100 crore calculator, education planning calculator India"
        ogImage="https://customer-assets.emergentagent.com/job_rubicon-funds/artifacts/7akuxub4_LOGO.png"
      />
      <InvestmentCalculators />
    </div>
  );
};

export default CalculatorsPage;
